import React from 'react';

export default function NoMatch() {
  return (
    <div>
      <h1>404 - Page Not Found</h1>
    </div>
  );
}
